// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gen-modal-container {
	background-color: rgba(0, 0, 0, 0.5);
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;

	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	box-sizing: border-box;
}

.gen-modal-content {
	min-height: 256px;
	max-height: 452px;
	background-color: white;
	border-radius: 8px;
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.gen-modal-content .gen-modal-btns {
	display: flex;
	justify-content: space-between;
	margin-top: 46px;
	gap: 8px;
}

#gen-modal-btn {
	margin: 0px;
	height: 40px;
	border-radius: 8px;
	box-shadow: none;
	font-size: 16px;
	text-transform: none;
}

#gen-modal-btn:hover {
	box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/Modal/GeneralModal/general-modal.css"],"names":[],"mappings":"AAAA;CACC,oCAAoC;CACpC,eAAe;CACf,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,aAAa;;CAEb,sBAAsB;CACtB,8BAA8B;CAC9B,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,uBAAuB;CACvB,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,gBAAgB;CAChB,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;AACjB","sourcesContent":[".gen-modal-container {\n\tbackground-color: rgba(0, 0, 0, 0.5);\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\n\tflex-direction: column;\n\tjustify-content: space-between;\n\talign-items: center;\n\tbox-sizing: border-box;\n}\n\n.gen-modal-content {\n\tmin-height: 256px;\n\tmax-height: 452px;\n\tbackground-color: white;\n\tborder-radius: 8px;\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n}\n\n.gen-modal-content .gen-modal-btns {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-top: 46px;\n\tgap: 8px;\n}\n\n#gen-modal-btn {\n\tmargin: 0px;\n\theight: 40px;\n\tborder-radius: 8px;\n\tbox-shadow: none;\n\tfont-size: 16px;\n\ttext-transform: none;\n}\n\n#gen-modal-btn:hover {\n\tbox-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
